module.exports = __webpack_public_path__ + "static/img/succsTip.56514600.png";